import { Box, Card as CardBase } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SnackbarContent } from 'notistack';

export const Wrapper = styled(SnackbarContent)``;

export const Card = styled(CardBase)`
  width: 100%;
`;
export const TitleBox = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  background-color: ${(p) => p.theme.palette.primary[50]};
  padding: ${(p) => p.theme.spacing(1, 2)};
  gap: ${(p) => p.theme.spacing(1)};
`;

export const TitleBoxStart = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${(p) => p.theme.spacing(0.5)};
`;

export const TitleBoxEnd = styled(Box)`
  display: flex;
  align-items: center;
`;

export const MessageBox = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: start;
  justify-content: flex-start;
  padding: ${(p) => p.theme.spacing(1, 2)};
  gap: ${(p) => p.theme.spacing(1)};
`;
